const DEVOPS_GROUP = 'infrastructure@getcollate.io';
const OLD_NIGHTLY_DEPLOY_GROUPS = ['infrastructure@getcollate.io', 'solutionseng@getcollate.io'];

export const isDevops = (user) =>
  Array.isArray(user?.groups) && user.groups.includes(DEVOPS_GROUP);

export const canDeployOldNightly = (user) =>
  Array.isArray(user?.groups) && user.groups.some((g) => OLD_NIGHTLY_DEPLOY_GROUPS.includes(g));
